import { CERTIFICATE_HEALTH_DESCRIPTION } from 'api/documents/documents.model';
import { WarningCard, ErrorCard, SuccessCard } from 'components/BasicCard';

import NotProvidedValueCard from '../NotProvidedValueCard';
import ScoreDetail from '../ScoreDetail';

type Props = {
  value?: CERTIFICATE_HEALTH_DESCRIPTION;
};

const HealthDescription = ({ value }: Props) => {
  if (!value) {
    return <NotProvidedValueCard />;
  }

  switch (value) {
    case CERTIFICATE_HEALTH_DESCRIPTION.VERY_GOOD:
      return (
        <SuccessCard $justify="center">
          <ScoreDetail
            scoreLabel={CERTIFICATE_HEALTH_DESCRIPTION.VERY_GOOD}
            maxScore={4}
            score="4"
          />
        </SuccessCard>
      );

    case CERTIFICATE_HEALTH_DESCRIPTION.GOOD:
      return (
        <SuccessCard $justify="center">
          <ScoreDetail scoreLabel={CERTIFICATE_HEALTH_DESCRIPTION.GOOD} maxScore={4} score="3" />
        </SuccessCard>
      );
    case CERTIFICATE_HEALTH_DESCRIPTION.FAIR:
      return (
        <WarningCard $justify="center">
          <ScoreDetail scoreLabel={CERTIFICATE_HEALTH_DESCRIPTION.FAIR} maxScore={4} score="2" />
        </WarningCard>
      );
    case CERTIFICATE_HEALTH_DESCRIPTION.POOR:
    default:
      return (
        <ErrorCard $justify="center">
          <ScoreDetail scoreLabel={CERTIFICATE_HEALTH_DESCRIPTION.POOR} maxScore={4} score="1" />
        </ErrorCard>
      );
  }
};

export default HealthDescription;
